import React from 'react'
import { DomainRoute } from 'domains/shifts/utils/domain/routingComponents'
import { shiftsAccessControl } from 'domains/shifts/access-control/shiftsAccess.configuration'
import { DashSwitch } from 'legacy/dash-components/dash-switch/DashSwitch'
import { ShiftsListPage } from 'domains/shifts/pages/list/ShiftsListPage'
// @hygen:inject page-import

export const shiftsRouter = (
  <DomainRoute route="shifts" accessControl={shiftsAccessControl}>
    <DashSwitch>
      <DomainRoute exact route="shifts" component={ShiftsListPage} />
      {/* @hygen:inject router-route 
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
